import { useState, useEffect } from 'react';
import mockApi from '../api/mockApi';
import formatOrdinal from './ordinalFormater.js';
import useUserData from './useUserData';
import { getCookie } from '../data/Cookies';

export default function useRanking() {
    let id = getCookie("id");

    const {userData, getUserData} = useUserData();

    const [ranking, setRanking] = useState([]);

    const [place, setPlace] = useState(-1);

    const [solar, setSolar] = useState(-1);

    const [emissions, setEmissions] = useState(-1);

    const getRanking = async () => {
        try {
            const tableData = processResponse();
            tableData.sort((a, b) => a.emissions - b.emissions);
            determineRanking(tableData);
			setRanking(tableData);
            getUserData(id);
        } catch (error) {
            console.log(error)
        }
    };

    function processResponse() {
        var leaderboard = [];

        var entry = {id: 1, place: "1st", name: "Juan", emissions: 10, solar: 100};
        leaderboard.push(entry);

        var entry = {id: 2, place: "2nf", name: "Katherine", emissions: 20, solar: 100};
        leaderboard.push(entry);

        var entry = {id: 3, place: "3rd", name: "Birgitte", emissions: 30, solar: 100};
        leaderboard.push(entry);

        var entry = {id: 4, place: "4th", name: "Johann", emissions: 40, solar: 100};
        leaderboard.push(entry);

        var entry = {id: 5, place: "5th", name: "Aditya", emissions: 50, solar: 100};
        leaderboard.push(entry);

        var entry = {id: 6, place: "6th", name: "Weronika", emissions: 60, solar: 100};
        leaderboard.push(entry);

        return (leaderboard);
    }

    function determinaUserStats() {
        const name = "Juan";
        if (name === undefined || ranking === undefined) {
            return;
        }

        var placeNo = 1;
        ranking.forEach((entry) => {

            if (entry.name == name) {
                setPlace(placeNo);
                setSolar(entry.solar);
                setEmissions(entry.emissions);
            }

            placeNo ++;
        })
    }

    useEffect(determinaUserStats, [JSON.stringify(userData), JSON.stringify(ranking)]);

    function determineRanking(tableData) {
        var place = 1;
        tableData.forEach(function (entry) {
            entry.place = formatOrdinal(place);
            place ++;
        })
    }

    return {
            ranking: ranking,
            place: place,
            emissions: emissions,
            solar: solar,
            getRanking: getRanking
        };
};

